import http from "./http";

export const httpLogin = (data) => http.post("/api/login", data);
export const getCaptchaImage = () => {
  return http.get(`/api/captcha/captchaImage`);
};
export const getUserInfo = () => {
  return http.get(`/api/getUserInfo`);
};
